export default function RatingIcon({ className = "", onClick = null , border= null , fill=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700">
        <defs>
          <style>
            {` .cls-1, .cls-2 {
        stroke-width: 0px;
      }

     `}
          </style>
        </defs>
        <path className="border-element" fill={border} d="M638.27,278.68l-75.82-11.66-118.08-18.16-53.87-107.12-34.47-68.53c-2.49-4.95-9.57-4.95-12.06,0l-34.47,68.53-53.87,107.12-118.08,18.16-75.82,11.66c-5.48.84-7.66,7.57-3.72,11.47l54.57,53.92,84.95,83.95-18.1,118.87-11.55,75.83c-.83,5.49,4.94,9.58,9.84,6.98l67.77-35.94,104.45-55.4,104.45,55.4,67.77,35.94c4.9,2.6,10.67-1.49,9.84-6.98l-11.55-75.83-18.08-118.77,85.05-84.05,54.57-53.92c3.94-3.9,1.76-10.63-3.72-11.47ZM454.07,412.11l21.56,141.6-125.69-66.66-125.69,66.66,21.57-141.71-101.38-100.18,141.18-21.71,64.38-128,64.38,128,141.18,21.71-101.49,100.29Z" />
        <polygon className="fill-element" fill={fill} points="454.07 412.11 475.63 553.71 349.94 487.05 224.25 553.71 245.82 412 144.44 311.82 285.62 290.11 350 162.11 414.38 290.11 555.56 311.82 454.07 412.11" />
      </svg>
    </>
  );
}